import * as CardCrawl from "@ravalmatic/cardcrawl-engine";

export type GameData = {
    muted: boolean;
    gold: number;
    specialCards: CardCrawl.SpecialCard[];
    tutorialSeen: boolean;
    language: string;
    numPlayedGames: number;
    data: any;
};

export enum Language {
    EN = "en",
    ES = "es",
    DE = "de",
    FR = "fr",
    IT = "it",
    PT = "pt",
    NL = "nl"
}

export enum EventType {
    GAME_PAUSED = "GAME_PAUSED",
    GAME_RESUMED = "GAME_RESUMED",
    CARD_PICKED = "CARD_PICKED",
    CARD_DROPPED = "CARD_DROPPED",
    CARD_DEALT = "CARD_DEALT",
    CARD_ADDED_TO_DECK = "CARD_ADDED_TO_DECK",
    MULLIGAN = "MULLIGAN",
    SHOW_CARD_DESCRIPTION = "SHOW_CARD_DESCRIPTION",
    HIDE_MESSAGE = "HIDE_MESSAGE",
    CLICK = "CLICK",
    CARD_RETURNED_TO_DECK = "CARD_RETURNED_TO_DECK",
    REMOVE_TUTORIAL_CURSOR = "REMOVE_TUTORIAL_CURSOR",
    EXTRA_ATTACK = "EXTRA_ATTACK"
}

export enum MessagePosition {
    TOP = "TOP",
    MIDDLE = "MIDDLE",
    BOTTOM = "BOTTOM"
}

export type TutorialStepData = {
    step: number;
    action: EventType;
    from: {tableau: CardCrawl.TableauType, i: number};
    allowedMoves: CardCrawl.AllowedMoves;
    message: string;
    messagePosition: MessagePosition;
    delay: number;
    t: number;
};
